import { createSelector } from 'reselect';

import { allProjectsSelector, timePeriodsSelector } from './base';
import { settingsSelector } from './settings';

export const projectsSelector = createSelector([allProjectsSelector], projects => [
        { id: -1, selectAll: true, name: 'All projects' },
        ...projects
    ]
);

export const activityTypesSelector = state => state.newdashboard.activity.get('activityTypes');
export const activityTypeIdsSelector = state => state.newdashboard.activity.get('activityTypeIds').toJS();
const getSummary = state => state.newdashboard.activity.get('summary');

export const summarySelector = createSelector([activityTypesSelector, getSummary], (activityTypes, summary) => {
    const summaryObj = summary && summary.toJS ? summary.toJS() : {};
    const summaries = activityTypes.toJS().reduce((acc, val) => {
        acc[val.value] = summaryObj[val.key];
        return acc;
    }, {});
    return summaries;
});

export const pageSelector = state => state.newdashboard.activity.get('page');
export const countSelector = state => state.newdashboard.activity.get('count');

const getTimePeriod = state => state.newdashboard.activity.get('timePeriod');
export const timePeriodSelector = createSelector([timePeriodsSelector, getTimePeriod], (list, item) => {
    const t = item || list[0];
    return t && t.toJS ? t.toJS() : t;
});

export const timePeriodInfoSelector = state => state.newdashboard.activity.get('timePeriodInfo').toJS();

export const projectSelector = createSelector([
    projectsSelector,
    state => state.newdashboard.activity.get('projectIds').toJS()
], (projects, projectIds) => {
    return projectIds.length === 1 ? projects.find(project => project.id === projectIds[0]) : projects[0];
});

export const activitiesSelector = state => state.newdashboard.activity.get('activities').toJS();
export const sizeSelector = createSelector([settingsSelector], settings => settings.activities.size);
export const loadingSelector = state => state.newdashboard.activity.get('loading');
export const uploadingSelector = state => state.newdashboard.activity.get('uploading');
export const stopScrollSelector = state => state.newdashboard.activity.get('stopScroll');

export const selectedSummariesSelector = createSelector([activityTypeIdsSelector, activityTypesSelector], (typeIds, types) => {
    return types.toJS().reduce((acc, val) => {
        acc[val.value] = typeIds.indexOf(val.key) !== -1;
        return acc;
    }, {});
});



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/selectors/activity.js